import { ConnectionPositionPair, Overlay, ScrollStrategy } from '@angular/cdk/overlay';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ColorEvent } from 'ngx-color';
import {
    ColorPickerPresetColors,
    LayerStyleGenerator
} from 'src/app/shared/map-data-services/layer/layer-style-generator';

@Component({
    selector: 'gsp-color-picker-rgb',
    templateUrl: './gsp-color-picker-rgb.component.html'
})
export class GspColorPickerComponent implements OnInit {
    @ViewChild('colorPickerContainer', { static: true })
    colorPickerContainer: ElementRef;

    @ViewChild('colorPicker', { static: true })
    colorPicker: ElementRef;

    @Input()
    disableOpacitySlider = true;

    @Input()
    colorValue: number;

    @Output()
    selectedColor = new EventEmitter<number>();

    @HostListener('body:click', ['$event'])
    bodyclick(event: MouseEvent): boolean {
        if (this.colorPickerContainer.nativeElement.contains(event.target)) {
            return false;
        }
        if (this.isPickerOpen) {
            this.isPickerOpen = false;
        }
    }

    public isPickerOpen = false;

    public colorValueHex: string;

    // Expose enum to template
    public presetColors = ColorPickerPresetColors;
    public scrollStrategy: ScrollStrategy;
    public preferredPositions: ConnectionPositionPair[] = [
        {
            panelClass: 'picker-dropdown',
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
            offsetX: 0,
            offsetY: 8
        },
        {
            panelClass: 'picker-dropup',
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
            offsetX: 0,
            offsetY: -8
        }
    ];

    constructor(private overlay: Overlay) {
        this.scrollStrategy = this.overlay.scrollStrategies.close();
    }

    ngOnInit(): void {
        if (this.colorValue === null || isNaN(this.colorValue)) {
            this.colorValueHex = LayerStyleGenerator.randomHexGenerator();
        } else {
            this.colorValueHex = LayerStyleGenerator.decimalToHexRgb(this.colorValue);
        }
        this.selectedColor.emit(LayerStyleGenerator.hexToDecimalRgb(this.colorValueHex));
    }

    public toggleColorPicker(): void {
        this.isPickerOpen = !this.isPickerOpen;
    }

    public colorSelected(selectEvent: ColorEvent) {
        this.colorValueHex = selectEvent.color.hex;

        this.selectedColor.emit(LayerStyleGenerator.hexToDecimalRgb(this.colorValueHex));
    }
}
